// src/components/schedule/Holidays.js
import React from 'react';
import { Calendar } from 'lucide-react';
import { useAtom } from 'jotai';
import { activeChildDetail } from '../../atomstore/store';
import { useRequestProcessor } from '../../requestProcessor';
import { fetchHolidayCalendarData } from '../../queryfunctions/queryfunctions';
import SpinnerLoading from '../common/SpinnerLoading';
import moment from 'moment';

const Holidays = () => {
    const { useQueryWrapper } = useRequestProcessor();
    const [activeChild] = useAtom(activeChildDetail);

    const { data: holidays = [], isLoading, isFetching } = useQueryWrapper(
        ['holidayCalendar', activeChild?.id],
        () => fetchHolidayCalendarData(activeChild)
    );

    if (isLoading || isFetching) {
        return (
            <div className="py-12 flex justify-center">
                <SpinnerLoading />
            </div>
        );
    }

    if (!Array.isArray(holidays) || holidays.length === 0) {
        return (
            <div className="bg-gray-100 rounded-2xl p-8 text-center">
                <p className="text-gray-500">No holidays or events found</p>
            </div>
        );
    }

    // Sort by date (nearest first)
    // Filter out past holidays and sort upcoming ones
    const sortedHolidays = [...holidays]
        .filter(holiday => new Date(holiday.holiday_date) >= new Date(new Date().setHours(0, 0, 0, 0)))
        .sort((a, b) => new Date(a.holiday_date) - new Date(b.holiday_date));


    return (
        <div className="space-y-3">
            <div className="bg-gradient-to-r from-pink-500 to-rose-500 rounded-2xl p-4 text-white">
                <h3 className="text-lg font-bold mb-1">Upcoming Holidays & Events</h3>
                <p className="text-sm opacity-90">
                    {moment().format('MMMM YYYY')}
                </p>
            </div>

            {sortedHolidays.map((holiday) => (
                <div
                    key={holiday.id}
                    className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100"
                >
                    <div className="flex items-start justify-between">
                        <div className="flex items-start space-x-3">
                            <div className="w-10 h-10 bg-gradient-to-br from-pink-400 to-red-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                <Calendar className="w-5 h-5 text-white" />
                            </div>
                            <div>
                                <p className="font-semibold text-gray-800">
                                    {holiday.title}
                                </p>
                                <p className="text-sm text-gray-500">
                                    {moment(holiday.holiday_date).format('DD MMM YYYY')}
                                </p>
                            </div>
                        </div>
                        <span
                            className={`text-xs px-2 py-1 rounded-lg font-medium bg-red-100 text-red-700
                                }`}
                        >
                            {'Holiday'}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Holidays;
